import React, { useState, useEffect } from "react";
import { Button, Flex, Text } from "@jsq/ds/core";
import { BulkActionsPanelProps } from "../../../types";
import { TicketRowItem } from "../../types";
import {
  bulkActionsPanel,
  bulkActionsPanelHeader,
  actionsSection,
  divider,
} from "./styles_vanilla.css";

export const BulkActionsPanel = ({ api, onOpenInJira }: BulkActionsPanelProps) => {
  const [selectedRows, setSelectedRows] = useState<TicketRowItem[]>([]);

  useEffect(() => {
    const onSelectionChanged = () => {
      const rows = api.getSelectedRows();
      setSelectedRows(rows);
    };

    api.addEventListener("selectionChanged", onSelectionChanged);

    return () => {
      api.removeEventListener("selectionChanged", onSelectionChanged);
    };
  }, [api]);

  const clearSelection = () => {
    api.deselectAll();
  };

  const handleOpenInJira = () => {
    onOpenInJira(selectedRows);
  };

  return (
    <Flex flexDirection="column" className={bulkActionsPanel} data-testid="bulk-actions-panel">
      <Flex
        alignItems="center"
        justifyContent="space-between"
        className={bulkActionsPanelHeader}
      >
        <Text variant="regular-md" data-testid="selected-count">
          {selectedRows.length} selected
        </Text>
        {selectedRows.length > 0 && (
          <Button variant="link" onClick={clearSelection} data-testid="clear-selection">
            Clear selection
          </Button>
        )}
      </Flex>
      <div className={divider} />
      <Flex flexDirection="column" className={actionsSection}>
        <Text variant="secondary-md" marginBottom="md">
          JIRA
        </Text>
        <Button
          variant="neutral"
          onClick={handleOpenInJira}
          data-testid="open-in-jira"
          disabled={selectedRows.length === 0}
        >
          Open tickets in Jira
        </Button>
      </Flex>
      <div className={divider} />
    </Flex>
  );
};
